import angular from 'angular';

import { default as orgDataService } from 'app/services/data/org.data.service';
import directive from './download-document.directive';
import controller from './download-document.directive.controller';

export default angular.module('app.components.global.downloadDocument', [
  orgDataService
])
  .directive('downloadDocument', directive)
  .controller('DownloadDocumentDirectiveController', controller)
  .name;

console.log('app.components.global.downloadDocument created');
